<div class="staff-leads-hub core-screen">
  @if (accessDenied()) {
    <p class="staff-leads-hub__state staff-leads-hub__state--error">
      {{ 'STAFF.LEADS.STATE.ACCESS_DENIED' | translate }}
    </p>
  } @else if (error()) {
    <div class="staff-leads-hub__state-wrap">
      <p class="staff-leads-hub__state staff-leads-hub__state--error">
        {{ 'STAFF.LEADS.STATE.LOAD_ERROR' | translate }}
      </p>
      <button type="button" class="staff-leads-hub__retry" (click)="refresh()">
        {{ 'STAFF.LEADS.STATE.RETRY' | translate }}
      </button>
    </div>
  } @else {
    <p class="staff-leads-hub__lead">
      {{ 'STAFF.LEADS.HUB.LEAD' | translate }}
    </p>

    <section class="staff-leads-hub__kpi-grid">
      @for (section of sections; track section.id) {
        <lib-staff-kpi-card
          [labelKey]="section.kpiKey"
          [value]="sectionValue(section.id)"
          [loading]="loading()"
          (cardClick)="openSection(section.id)"
        />
      }
    </section>

    <section class="staff-leads-hub__sections">
      @for (section of sections; track section.id) {
        <button
          type="button"
          class="staff-leads-hub__section-link"
          (click)="openSection(section.id)"
        >
          <span class="staff-leads-hub__section-title">{{
            section.labelKey | translate
          }}</span>
          @if (sectionValue(section.id) > 0) {
            <span class="staff-leads-hub__section-badge">{{
              sectionValue(section.id)
            }}</span>
          }
        </button>
      }
    </section>
  }
</div>
